<template>
  <section class="intro">
    <header class="header">
      <FlexWrap>
        <IntroAnimation />
        <div class="container">
          <h1 id="intro-end-trigger" class="title">Stemmenstrijd</h1>
          <Content dark>
            <p>Dat je mag stemmen is nu normaal, maar was dat vroeger ook zo? Reis door de tijd en ervaar zelf hoeveel (of weinig) macht jij had.</p>
          </Content>
          <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="27.414" height="8.021"><path d="M25.914 1.5L13.707 6.521 1.5 1.5" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>
        </div>
      </FlexWrap>
      <IntroKoets />
    </header>
    <div id="chapter-1-panel-2" class="bg-light">
      <div class="container">
        <Content>
          <p>Zo. We beginnen in 1815. Napoleon is net verslagen en de eerste verkiezingen voor de Tweede Kamer staan voor de deur. Maar stemmen? Dat was voor een hele kleine groep mensen.</p>
          <p>De vraag is: hoorde jij daarbij? In deze special krijg je het antwoord. Onderzoek of jij, in je huidige situatie, vroeger had mogen stemmen.</p>
        </Content>
      </div>
      <FlexWrap>
        <CharacterChoice />
      </FlexWrap>
    </div>
  </section>
</template>

<script>
import { Content, FlexWrap } from '@/components/chapter'
import { chapterMixin } from '@/mixins'
import IntroAnimation from './IntroAnimation'
import IntroKoets from './IntroKoets'
import CharacterChoice from './character-choice'

export default {
  name: 'Intro',
  mixins: [chapterMixin],
  components: {
    Content,
    IntroAnimation,
    IntroKoets,
    FlexWrap,
    CharacterChoice
  }
}
</script>

<style lang="scss" scoped>
.intro {
  overflow: hidden;
}

.bg-light {
  padding-top: 140px;

  @media (min-width: 768px) {
    padding-top: 220px;
  }
}

.container {
  position: relative;
  z-index: 2;
}

.header {
  background-color: $c-turq;
  text-align: center;
  padding-top: 40px;

  @media (min-width: 768px) {
    padding-top: 0;
  }
}

.title {
  font-size: 52px;
  color: white;
  font-weight: $fw-bold;
  line-height: 62px;
  margin: 0 auto 8px;
  text-transform: uppercase;

  @media (max-width: 767px) {
    font-size: 36px;
  }

  @media (max-width: 349px) {
    font-size: 30px;
  }
}

.chevron {
  margin: 40px auto 100px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
}
</style>
